const swapsMainNet = new Map();
const swapsTestNet = new Map();

swapsMainNet.set('QuickSwap', {
  url: 'https://quickswap.exchange/#/swap?outputCurrency=:token',
  urlLp: 'https://quickswap.exchange/#/add/:token',
});

export { swapsMainNet, swapsTestNet };
